// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sql-background-panel {
  width: 100%;
  height: 100%;
  padding: 5px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.sql-title-div {
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
}

.sql-title {
  flex: 1 1 100%;
  display: flex;
}

.sql-refresh-button {
  flex: 1 1 auto;
  padding-left: 5px;
  vertical-align: middle;
  align-self: flex-end;
}

.sql-table {
  width: 100%;
  height: 100%;
}

.table-cell {
  width: 100%;
  height: 100%;
  padding: 5px;
  border: 0.5px solid black;
  display: flex;
}

.table-cell span {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/supervision components/sql-table/sql-table.component.scss","webpack://./src/components/supervision%20components/sql-table/sql-table.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EAEA,aAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;ACAJ;;ADGA;EACI,cAAA;EACA,WAAA;EAEA,aAAA;EACA,qBAAA;ACDJ;;ADIA;EACI,cAAA;EAEA,aAAA;ACFJ;;ADKA;EACI,cAAA;EACA,iBAAA;EACA,sBAAA;EAEA,oBAAA;ACHJ;;ADMA;EACI,WAAA;EACA,YAAA;ACHJ;;ADMA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EAEA,aAAA;ACJJ;;ADOA;EACI,WAAA;ACJJ","sourcesContent":[".sql-background-panel{\n    width:100%;\n    height:100%;\n    padding: 5px;\n\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: center;\n    align-items: center;\n}\n\n.sql-title-div{\n    flex: 1 1 auto;\n    width: 100%;\n\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.sql-title{\n    flex: 1 1 100%;\n\n    display: flex;\n}\n\n.sql-refresh-button{\n    flex: 1 1 auto;\n    padding-left: 5px;\n    vertical-align: middle;\n\n    align-self: flex-end;\n}\n\n.sql-table{\n    width:100%;\n    height:100%;\n}\n\n.table-cell{\n    width:100%;\n    height:100%;\n    padding:5px;\n    border: 0.5px solid black;\n\n    display: flex;\n}\n\n.table-cell span{\n    width:100%;\n}",".sql-background-panel {\n  width: 100%;\n  height: 100%;\n  padding: 5px;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.sql-title-div {\n  flex: 1 1 auto;\n  width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n}\n\n.sql-title {\n  flex: 1 1 100%;\n  display: flex;\n}\n\n.sql-refresh-button {\n  flex: 1 1 auto;\n  padding-left: 5px;\n  vertical-align: middle;\n  align-self: flex-end;\n}\n\n.sql-table {\n  width: 100%;\n  height: 100%;\n}\n\n.table-cell {\n  width: 100%;\n  height: 100%;\n  padding: 5px;\n  border: 0.5px solid black;\n  display: flex;\n}\n\n.table-cell span {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
